module.exports = __webpack_public_path__ + "media/images/quote-gold-c1aa4bc42183cbed0cf83ba356685ea6.svg";